var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.09998 6.10022C6.47503 5.72528 6.98365 5.51465 7.51398 5.51465C8.04431 5.51465 8.55292 5.72528 8.92798 6.10022L16 13.1722L23.072 6.10022C23.4492 5.73591 23.9544 5.53432 24.4788 5.53887C25.0032 5.54343 25.5048 5.75377 25.8756 6.12458C26.2464 6.4954 26.4568 6.99703 26.4613 7.52142C26.4659 8.04581 26.2643 8.55102 25.9 8.92822L18.828 16.0002L25.9 23.0722C26.2643 23.4494 26.4659 23.9546 26.4613 24.479C26.4568 25.0034 26.2464 25.505 25.8756 25.8759C25.5048 26.2467 25.0032 26.457 24.4788 26.4616C23.9544 26.4661 23.4492 26.2645 23.072 25.9002L16 18.8282L8.92798 25.9002C8.55077 26.2645 8.04557 26.4661 7.52117 26.4616C6.99678 26.457 6.49516 26.2467 6.12434 25.8759C5.75352 25.505 5.54319 25.0034 5.53863 24.479C5.53407 23.9546 5.73566 23.4494 6.09998 23.0722L13.172 16.0002L6.09998 8.92822C5.72503 8.55317 5.5144 8.04455 5.5144 7.51422C5.5144 6.98389 5.72503 6.47528 6.09998 6.10022V6.10022Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.9f5724510454298963c9dcdaac25b606.svg";
export { ForwardRef as ReactComponent };